import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { EmptyDataDiv, Footer, Header, ListingResultText, MixPanelTrackedLink, PageListCard, SearchInput } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { fundRaiserPageAction } from "../../store/actions";
import { FundraisersListSkeleton } from "../../components/skeletons";
import HelmetMetaData from "./HelmetMetaData";
import { FilterModal } from "../../components/modals";
import { fundraiserAPIs } from "../../api";
import { filtersState as initialFiltersState } from "../../states";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "../../helpers";
import { FiltersIcon } from "../../components/Icons";
import { useNonInitialEffect } from "../../hooks/UseNonInitialEffect";
import { Box, Container, Grid, Stack } from "@mui/material";
import { isMobile } from "react-device-detect";
import Tracking from "../../services/tracking.service";
import { PAGENAME_CONSTANTS } from "../../constants";

export function FundRaiserList() {
    const dispatch = useDispatch();
    const [state, setState] = useState(initialFiltersState);
    const [fundraisersList, setFundraisersList] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0)
    const [loadingPages, setLoadingPages] = useState(false);
    const [openFiltersModal, setOpenFiltersModal] = useState(false);
    const [loadingMorePages, setLoadingMorePages] = useState(false);
    const minMaxRange = useSelector(state => state.fundraiser_page.min_max_range);

    const locationDetails = useSelector(state => state.fundraiser_page.location_details);
    const TITLE = 'The Citizens Foundation';
    const DESCRIPTION = 'Fundraise for Education. Create your personal fundraiser and rally your friends and family to provide quality education to children in Pakistan.';

    const mapFundraiserPages = () => {
        return fundraisersList.map(list => {
            return <Grid key={list.id} item xs={6} sm={4} sx={styles.item}>
                <PageListCard page={list} key={list.id} />
            </Grid>
        })
    }

    // const updateState = (e) => {
    //     const { name, value } = e.target;
    //     if (name == "sortBy") {
    //         setLoadingMoreData(true);
    //         setState({
    //             ...state,
    //             [name]: value.id,
    //             offset: 0
    //         })
    //     }
    // }
    const loadMorePages = async () => {
        setLoadingMorePages(true);
        setState({
            ...state,
            offset: state.offset + 21
        })
    }
    const getAndSetFundraiserList = async (payload, applyingNewFilter = false) => {
        setLoadingPages(true);
        const response = await fundraiserAPIs.getAllFundraisers(payload)
        if (response.data) {
            setTotalRecords(response.data.data.total)
            applyingNewFilter ? setFundraisersList([...response.data.data.result]) : setFundraisersList([...fundraisersList, ...response.data.data.result])
            setLoadingPages(false);
            setLoadingMorePages(false);
        }
    }

    const openModal = () => {
        setOpenFiltersModal(true)
    }

    const applyFilter = async (payload) => {
        payload.offset = 0;
        await getAndSetFundraiserList(payload, true)
        setState({
            ...payload,
        })
        if (payload.selectedFiltersCount !== 0) setOpenFiltersModal(false)
    }
    const resetFilters = (e) => {
        e.preventDefault();
        applyFilter(initialFiltersState);
    }

    const searchClick = async () => {
        // setSearchingPages(true);
        // if (state.offset == 0) {
        //     await getAndSetFundraiserList(state, true)
        //     setSearchingPages(false);
        // }
        // let payload = { ...state }
        // payload.offset = 0;

        // else 
        setState({
            ...state,
            offset: 0
        })
    }
    useEffect(() => {
        dispatch(fundRaiserPageAction.getUserDefaultCurrency());
        Tracking.trackPage({pageName: PAGENAME_CONSTANTS.FUNDRAISERS})
    }, [])

    useEffect(() => {
        if (locationDetails) {
            const payload = {
                countries: [],
                offset: 0,
                // sortBy: TRENDING
            }
            if (locationDetails.is_exist) {
                payload.countries = [locationDetails.country_id]
                setState({
                    ...state,
                    countries: [locationDetails.country_id],
                    selectedFiltersCount: 1
                })
            }
            !fundraisersList.length && getAndSetFundraiserList(payload)
        }
    }, [locationDetails])

    useEffect(() => {
        if (state.countries.length == 1)
            dispatch(fundRaiserPageAction.getMinMaxGoalRange(state.countries[0]));
    }, [state.countries])

    useEffect(() => {
        if (state.countries.length == 1 && minMaxRange.max_range !== 0)
            setState({
                ...state,
                goalRange: { min: minMaxRange.min_range, max: minMaxRange.max_range }
            })
    }, [minMaxRange])

    useNonInitialEffect(() => {
        if (loadingMorePages)
            getAndSetFundraiserList(state);
        else if (state.offset == 0)
            getAndSetFundraiserList(state, true);
    }, [state.offset, state.searchString])

    const handleSearchChange = e => {
        setState({
            ...state,
            offset: 0,
            searchString: e.target.value
        });
        setLoadingPages(true)
    }

    const handleSearch = React.useCallback(debounce(handleSearchChange, 500), []);

    // useEffect(() => {
    //     if (loadingMoreData) {
    //         getAndSetFundraiserList(state, true);
    //     }
    // }, [state.sortBy])
    return <Box className="App-display-height">
        <Header />
        <Container component="main" className="App-content">
            <FilterModal globalState={state} open={openFiltersModal} setOpen={setOpenFiltersModal} applyFilter={applyFilter} />
            <Stack direction="row" spacing={2}>
                <SearchInput
                    size="small"
                    placeholder="Search Here"
                    sx={styles.searchField}
                    onChange={handleSearch}
                    onKeyDown={e => e.key == 'Enter' && searchClick()}
                />
                <MixPanelTrackedLink type="button"
                    label="Filter"
                    context="Fundraiser listing page"
                    variant="outlined"
                    onClick={openModal} startIcon={<FiltersIcon />}>
                    Filter
                </MixPanelTrackedLink>
            </Stack>
            <ListingResultText resultCount={totalRecords} filtersCount={state.selectedFiltersCount} resetHandler={resetFilters} />
            {fundraisersList.length ? (
                <InfiniteScroll
                    dataLength={fundraisersList.length} //This is important field to render the next data
                    next={loadMorePages}
                    hasMore={fundraisersList.length < totalRecords}
                    loader={<div style={{ textAlign: "center" }}><CircularProgress thickness={2} /></div>}
                    style={styles.infinityLoader}
                >
                    <Grid container justifyContent="space-between" spacing={{xs: 0, sm: 4}} sx={styles.container}>
                        {mapFundraiserPages()}
                        {/* Added the following item to balance the UI if a row contains two records */}
                        <Grid item xs={5.5} sm={3.5}></Grid>
                    </Grid>

                </InfiniteScroll>
            ) : loadingPages ? <FundraisersListSkeleton /> : <EmptyDataDiv message="No records found" />}
        </Container>
        <Footer />
    </Box>
}

const styles = {
    container: {
        gap: isMobile ? '5px' : 'unset',
        marginTop: '0 !important'
    },
    item: {
        maxWidth: isMobile ? 'calc(50% - 2.5px)' : 'unset'
    },
    searchField: {
        '& .MuiInputBase-input': {
            fontSize: '0.875rem'
        }
    },
    infinityLoader: {
        overflow: 'none',
        // marginTop: '30px'
    }
}